import {
    CARE_PASSWORD,
    SERVER_URL,
    CARE_USERNAME,
} from "../../constants/constants"
import { fileUploadMultipart, get, post } from "./methods"


export function getUserProfileReport(type,data) {
    // console.log("data", data);    
    return post({
        url: `${SERVER_URL}/care/v1/${type}/users`,
        json: JSON.stringify(data),
        username: CARE_USERNAME,
        password: CARE_PASSWORD,
        isJsonResponse: false,
        isTextResponse: true,
        reqContentType: "application/json",
    })
}

export function getAuditTrailReport(data) {
    console.log("data", data);
    return post({
        url: `${SERVER_URL}/care/v1/audits`,
        json: JSON.stringify(data),
        username: CARE_USERNAME,
        password: CARE_PASSWORD,
        isJsonResponse: false,
        isTextResponse: true,
        reqContentType: "application/json",
    })
}